var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2500px",
    height: "1667px",
    viewBox: "0 0 2500 1667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 2500,
    height: 1667
  }), /*#__PURE__*/React.createElement("path", {
    id: "B16",
    d: "M2357,247 L2357,323 L2004.87452,323 L1953.87452,407 L1800.73231,407 L1758.73231,496 L1718.7372,496 L1708.53732,517.419739 L1595,561.08794 L1595,499.330707 L1711.49613,450.541729 L1721.28783,429 L1761.29694,429 L1803.29694,335 L1956.14126,335 L2008.14126,247 L2357,247 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B15",
    d: "M2357,327 L2357,407 L2004.93353,407 L1953.93353,483 L1800.76393,483 L1758.76393,567 L1718.79254,567 L1708.59235,586.380351 L1595,627.157092 L1595,565.373598 L1711.46268,520.580261 L1721.2628,500 L1761.26769,500 L1803.26769,411 L1956.12548,411 L2007.12548,327 L2357,327 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B14",
    d: "M2357,411 L2357,488 L2004.96576,488 L1953.96576,560 L1800.80541,560 L1758.80541,638 L1718.82319,638 L1708.6295,656.348648 L1595,694.225148 L1595,631.40701 L1711.40765,589.619649 L1721.20746,571 L1761.23607,571 L1803.23607,487 L1956.06647,487 L2007.06647,411 L2357,411 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B13",
    d: "M2357,492 L2357,570 L2005,570 L1954,638 L1800.85937,638 L1758.85937,709 L1718.85611,709 L1708.66977,726.316766 L1595,761.292081 L1595,698.441518 L1711.3705,659.651352 L1721.17681,642 L1761.19459,642 L1803.19459,564 L1956.03424,564 L2007.03424,492 L2357,492 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B12",
    d: "M2357,574 L2357,651 L2005.04586,651 L1954.04586,714 L1800.90211,714 L1758.90211,780 L1718.92963,780 L1708.74583,795.275711 L1595,827.357867 L1595,765.477149 L1711.33023,729.683234 L1721.14389,713 L1761.14063,713 L1803.14063,642 L1956,642 L2007,574 L2357,574 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B11",
    d: "M2357,655 L2357,734 L2005.10578,734 L1954.10578,791 L1800.94883,791 L1758.94883,852 L1719.06325,852 L1708.87162,864.229962 L1595,894.401074 L1595,831.513928 L1711.25417,798.724289 L1721.07037,784 L1761.09789,784 L1803.09789,718 L1955.95414,718 L2006.95414,655 L2357,655 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B10",
    d: "M2357,738 L2357,816 L2005.16018,816 L1954.16018,868 L1801.02183,868 L1759.02183,922 L1719.06325,922 L1708.89445,934.202564 L1595,960.485898 L1595,898.539097 L1711.12838,867.770038 L1720.93675,856 L1761.05117,856 L1803.05117,795 L1955.89422,795 L2006.89422,738 L2357,738 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B9",
    d: "M2357,820 L2357,900 L2005.24379,900 L1954.24379,945 L1801.08013,945 L1759.08013,994 L1719.17157,994 L1709.01018,1004.1614 L1595,1027.5481 L1595,964.591025 L1711.10555,937.797436 L1720.93675,926 L1760.97817,926 L1802.97817,872 L1955.83982,872 L2006.83982,820 L2357,820 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B8",
    d: "M2357,904 L2357,982 L2005.30924,982 L1954.30924,1022 L1801.17157,1022 L1759.17157,1064 L1719.17157,1064 L1709.02289,1074.14868 L1595,1095.58888 L1595,1031.63139 L1710.98982,1007.8386 L1720.82843,998 L1760.91987,998 L1802.91987,949 L1955.75621,949 L2006.75621,904 L2357,904 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B7",
    d: "M2006.69076,986 L2357,986 L2357,1064 L2005.39445,1064 L1954.39445,1098 L1801.24469,1098 L1759.20225,1135.03739 L1719.40021,1137.02749 L1709.30775,1143.08297 L1595,1160.66878 L1595,1099.65898 L1710.97711,1077.85132 L1720.82843,1068 L1760.82843,1068 L1802.82843,1026 L1955.69076,1026 L2006.69076,986 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B6",
    d: "M2357,1068 L2357,1146 L2005.45538,1146 L1954.45538,1176 L1801.35907,1176 L1759.35907,1206 L1719.29844,1206 L1709.19602,1214.08194 L1595,1227.74642 L1595,1164.71584 L1710.69225,1146.91703 L1720.59979,1140.97251 L1760.79775,1138.96261 L1802.75531,1102 L1955.60555,1102 L2006.60555,1068 L2357,1068 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B5",
    d: "M2357,1150 L2357,1228 L2005.55293,1228 L1954.55293,1252 L1801.43105,1252 L1759.43105,1278 L1719.52786,1278 L1709.43242,1283.04772 L1595,1294.78438 L1595,1231.77495 L1710.80398,1217.91806 L1720.70156,1210 L1760.64093,1210 L1802.64093,1180 L1955.54462,1180 L2006.54462,1150 L2357,1150 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B4",
    d: "M2357,1232 L2357,1329 L2005.69364,1329 L1954.69364,1345 L1801.61058,1345 L1759.61058,1362 L1719.61484,1362 L1709.54142,1366.02937 L1595,1374.84025 L1595,1298.80536 L1710.56758,1286.95228 L1720.47214,1282 L1760.56895,1282 L1802.56895,1256 L1955.44707,1256 L2006.44707,1232 L2357,1232 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B3",
    d: "M2357,1333 L2357,1410 L2005.78677,1410 L1954.78677,1421 L1801.69755,1421 L1759.69755,1434 L1719.61484,1434 L1709.58203,1438.01312 L1595,1441.93046 L1595,1378.85206 L1710.45858,1369.97063 L1720.38516,1366 L1760.38942,1366 L1802.38942,1349 L1955.30636,1349 L2006.30636,1333 L2357,1333 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B2",
    d: "M2357,1414 L2357,1508 L2005.92991,1508 L1948.92991,1512 L1792.87923,1512 L1759.87923,1516 L1719.61484,1516 L1709.61484,1520 L1595,1520 L1595,1445.93279 L1710.41797,1441.98688 L1720.38516,1438 L1760.30245,1438 L1802.30245,1425 L1955.21323,1425 L2006.21323,1414 L2357,1414 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B1",
    d: "M2357,1512 L2357,1588 L1595,1588 L1595,1524 L1710.38516,1524 L1720.38516,1520 L1760.12077,1520 L1793.12077,1516 L1949.07009,1516 L2006.07009,1512 L2357,1512 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A16",
    d: "M1556,208 L1556,339 L1205,339 L1205,361 L907.380422,361 L896.380422,332 L545,332 L545,293 L719,293 L719,229 L1207,229 L1207,208 L1556,208 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A15",
    d: "M893.619578,336 L904.619578,365 L1209,365 L1209,343 L1556,343 L1556,423 L1205,423 L1205,443 L907.396873,443 L896.396873,413 L377,413 L377,375 L545,375 L545,336 L893.619578,336 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A14",
    d: "M893.603127,417 L904.603127,447 L1209,447 L1209,427 L1556,427 L1556,504 L1205,504 L1205,525 L907.344797,525 L896.344797,498 L377,498 L377,417 L893.603127,417 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A13",
    d: "M893.655203,502 L904.655203,529 L1209,529 L1209,508 L1556,508 L1556,586 L1205,586 L1205,604 L907.283396,604 L896.283396,580 L209,580 L209,586 L186,586 L186,557 L213,557 L213,534 L377,534 L377,502 L893.655203,502 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A12",
    d: "M893.716604,584 L904.716604,608 L1209,608 L1209,590 L1556,590 L1556,669 L1205,669 L1205,687 L907.260443,687 L896.260443,664 L209,664 L209,683 L186,683 L186,590 L213,590 L213,584 L893.716604,584 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A11",
    d: "M893.739557,668 L904.739557,691 L1209,691 L1209,673 L1556,673 L1556,751 L1205,751 L1205,768 L907.236068,768 L896.236068,746 L209,746 L209,764 L186,764 L186,687 L213,687 L213,668 L893.739557,668 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A10",
    d: "M893.763932,750 L904.763932,772 L1209,772 L1209,755 L1556,755 L1556,832 L1205,832 L1205,849 L907.088054,849 L896.088054,832 L209,832 L209,845 L186,845 L186,768 L213,768 L213,750 L893.763932,750 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A9",
    d: "M893.911946,836 L904.911946,853 L1209,853 L1209,836 L1556,836 L1556,916 L1205,916 L1205,930 L907.121669,930 L896.121669,912 L209,912 L209,926 L186,926 L186,849 L213,849 L213,836 L893.911946,836 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A8",
    d: "M893.878331,916 L904.878331,934 L1209,934 L1209,920 L1556,920 L1556,998 L1205,998 L1205,1008 L906.927598,1008 L895.927598,995 L209,995 L209,1008 L186,1008 L186,930 L213,930 L213,916 L893.878331,916 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A7",
    d: "M894.072402,999 L905.072402,1012 L1209,1012 L1209,1002 L1556,1002 L1556,1081 L1205,1081 L1205,1091 L906.927598,1091 L895.927598,1078 L209,1078 L209,1087 L186,1087 L186,1012 L213,1012 L213,999 L894.072402,999 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A6",
    d: "M894.072402,1082 L905.072402,1095 L1209,1095 L1209,1085 L1556,1085 L1556,1161.01702 L1205,1164.01702 L1205,1173 L906.879803,1173 L895.879803,1161 L209,1161 L209,1170 L186,1170 L186,1091 L213,1091 L213,1082 L894.072402,1082 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A5",
    d: "M894.120197,1165 L905.120197,1177 L1209,1177 L1209,1167.98298 L1556,1165.01717 L1556,1245 L1202,1245 L1202,1251 L905.701562,1251 L895.701562,1243 L209,1243 L209,1251 L186,1251 L186,1174 L213,1174 L213,1165 L894.120197,1165 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A4",
    d: "M894.298438,1247 L904.298438,1255 L1206,1255 L1206,1249 L1556,1249 L1556,1327 L1202,1327 L1202,1333 L905.701562,1333 L895.701562,1325 L186,1325 L186,1255 L213,1255 L213,1247 L894.298438,1247 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A3",
    d: "M894.298438,1329 L904.298438,1337 L1206,1337 L1206,1331 L1556,1331 L1556,1410 L1202,1410 L1202,1417 L905.630444,1417 L895.630444,1410 L186,1410 L186,1329 L894.298438,1329 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A2",
    d: "M894.369556,1414 L904.369556,1421 L1207,1421 L1207,1414 L1556,1414 L1556,1505 L186,1505 L186,1414 L894.369556,1414 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A1",
    d: "M1556,1509 L1556,1605 L186,1605 L186,1509 L1556,1509 Z",
    stroke: "#FFD426",
    strokeWidth: 4,
    fillOpacity: 0.2,
    fill: "#FFD426"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBuilding);
export default __webpack_public_path__ + "static/media/select_building.c65d283b.svg";
export { ForwardRef as ReactComponent };